import iTable from '../../../components/Table.vue'
import IPagination from '../../../components/pagination.vue'
import Btn from './btn.vue'

export default {
  name: 'TerminalCommand',
  components: { iTable, IPagination },
  data() {
    return {
      isCollapse: false,
      stateArrow: true,
      typeId: '',
      terminalList: [],
      height: '550',
      list: [],
      option: {
        stripe: true,
        border: true,
        loading: false,
        highlightCurrentRow: false,
        mutiSelect: true,
        serialNumber: true,
      },
      columns: [
        {
          prop: 'name',
          label: this.$t('TerminalCommand.name'),
          align: 'center',
          width: '360px',
        },
        {
          prop: 'aliKey',
          label: this.$t('TerminalCommand.aliKey'),
          align: 'center',
          width: '260px',
        },
        {
          prop: 'keyTypeStr',
          label: this.$t('TerminalCommand.keyType'),
          align: 'center',
          width: '160px',
        },
        {
          prop: 'sort',
          label: this.$t('TerminalCommand.sort'),
          align: 'center',
          width: '160px',
          sortable: true,
        },
        {
          prop: 'explain',
          label: this.$t('TerminalCommand.explain'),
          align: 'center',
          width: '400px',
        },
        {
          prop: 'state',
          label: this.$t('common.btn.operate'),
          align: 'center',
          width: '200px',
          render: (h, params) => {
            return h(Btn, {
              props: {
                list: this.btnList,
                item: params,
              },
              on: {
                clickBtn: (row) => {
                  const state = params.row.state === 1 ? 0 : 1
                  this.updateState(params.row, state)
                },
              },
            })
          },
        },
      ],
      btnList: [
        {
          label: this.$t('TerminalCommand.begin'),
          type: 'primary',
          filed: 'begin',
          disabled: 'is_begin',
        },
        { label: this.$t('TerminalCommand.stop'), filed: 'disable', disabled: 'is_disable' },
      ],
      operates: {
        width: 100,
        fixed: 'right',
        list: [],
      },
      currentPage: 1,
      pageSize: 10,
      total: 1,
      dialogFormVisible: false,
      formLabelWidth: '100px',
      diaTitle: '',
      rules: {
        terminalType: [
          { required: true, message: this.$t('TerminalCommand.form.terminalType'), trigger: 'blur' },
        ],
        productKey: [
          { required: true, message: this.$t('TerminalCommand.form.productKey'), trigger: 'blur' },
        ],
      },
      form: {
        terminalType: '',
        productKey: '',
      },
      dialogCommandFormVisible: false,
      diaCommandTitle: '',
      btnCommand: '',
      CommandRules: {
        name: [{ required: true, message: this.$t('TerminalCommand.form.name'), trigger: 'blur' }],
        aliKey: [
          { required: true, message: this.$t('TerminalCommand.form.aliKey'), trigger: 'blur' },
        ],
        keyType: [
          { required: true, message: this.$t('TerminalCommand.form.keyType'), trigger: 'change' },
        ],
        sort: [{ required: true, message: this.$t('TerminalCommand.form.sort'), trigger: 'blur' }],
        unit: [{ required: true, message: this.$t('TerminalCommand.form.unit'), trigger: 'blur' }],
        isShow: [
          { required: true, message: this.$t('TerminalCommand.form.isShow'), trigger: 'change' },
        ],
      },
      CommandForm: {
        name: '',
        aliKey: '',
        keyType: '',
        sort: 1,
        explain: '',
        unit: '',
        isShow: '',
      },
      keyTypeList: [],
      selected: [],
      id: '',
    }
  },
  created() {
    this.getTerminalType()
  },
  methods: {
    toggleSideBar() {
      this.isCollapse = !this.isCollapse
      this.$store.dispatch('menuTab/toggleSideBar', this.isCollapse)
    },
    changeArrow() {
      this.stateArrow = !this.stateArrow
    },
    getTerminalType() {
      this.$store
        .dispatch('TerminalCommand/GET_TERMINALTYPE', {})
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.terminalList = res.data.data
              this.typeId = res.data.data[0].id
              this.getInstructionType()
            }
          }
        })
        .catch((err) => { })
    },
    getInstructionType() {
      let param = {
        isShowHidden: 1,
        typeId: this.typeId,
        pageNum: this.currentPage,
        pageSize: this.pageSize,
      }
      this.$store
        .dispatch('TerminalCommand/GET_SELECTALIKEY', param)
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              this.list = res.data.data.list
              this.list.map((item) => {
                if (item.state === 1) {
                  item['is_begin'] = true
                  item['is_disable'] = false
                } else {
                  item['is_begin'] = false
                  item['is_disable'] = true
                }
              })
              this.$refs.page.CommandTotal = res.data.data.total
            }
          }
        })
        .catch((err) => { })
    },
    updateState(row, index) {
      let param = {
        id: row.id,
        state: index,
        operationType: 2,
      }
      this.$store
        .dispatch('TerminalCommand/GET_INSERTALIKEY', param)
        .then((res) => {
          if (res) {
            if (res.data.code == 200) {
              if (index == 1) {
                this.$message.success(this.$t('TerminalCommand.beginSuccess'))
              } else {
                this.$message.success(this.$t('TerminalCommand.stopSuccess'))
              }
              this.getInstructionType()
            } else {
              this.$message.success(res.data.msg)
            }
          }
        })
        .catch((err) => { })
    },
    ChangTerminal(val) {
      this.typeId = val
      this.getInstructionType()
    },
    addType() {
      this.dialogFormVisible = true
      this.diaTitle = this.$t('TerminalCommand.newModel')
      this.$refs.form.resetFields()
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let param = {
            terminalType: this.form.terminalType,
            productKey: this.form.productKey,
            operationType: 1,
            unit: 1,
          }
          this.$store
            .dispatch('TerminalCommand/GET_INAERTTYPE', param)
            .then((res) => {
              if (res.data.code == 200) {
                this.$message.success(this.$t('common.btn.addSuccess'))
                this.dialogFormVisible = false
                this.getTerminalType()
                this.closeDia()
              } else {
                this.$message.error(res.data.msg)
              }
            })
            .catch((err) => { })
        } else {
          return false
        }
      })
    },
    cancle(formName) {
      this.dialogFormVisible = false
      this.form = {
        terminalType: '',
        productKey: '',
      }
    },
    closeDia() {
      this.form = {
        terminalType: '',
        productKey: '',
      }
      this.dialogFormVisible = false
    },
    deleteType() {
      this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'), {
        cancelButtonText: this.$t('common.btn.cancel'),
        confirmButtonText: this.$t('common.btn.confirm'),
        type: 'warning',
      })
        .then((res) => {
          let param = { id: this.typeId }
          this.$store
            .dispatch('TerminalCommand/GET_DELETETYPE', param)
            .then((response) => {
              if (response.data.code == 200) {
                this.getTerminalType()
                this.$message.success(this.$t('common.btn.deleteSuccess'))
              } else {
                this.$message.error(response.data.msg)
              }
            })
            .catch((error) => { })
        })
        .catch((err) => { })
    },
    addCommand() {
      this.dialogCommandFormVisible = true
      this.diaCommandTitle = this.$t('common.btn.add')
      this.btnCommand = 'add'
      this.$nextTick(() => {
        this.$refs.CommandForm.resetFields()
        this.clear()
      })
    },
    editCommand() {
      this.dialogCommandFormVisible = true
      this.diaCommandTitle = this.$t('common.btn.edit')
      this.btnCommand = 'edit'
      this.$nextTick(() => {
        this.$refs.CommandForm.clearValidate()
      })
      this.CommandForm.name = this.selected[0].name
      this.CommandForm.aliKey = this.selected[0].aliKey
      this.CommandForm.keyType = String(this.selected[0].keyType)
      this.CommandForm.explain = this.selected[0].explain
      this.CommandForm.unit = this.selected[0].unit
      this.CommandForm.isShow = String(this.selected[0].isShow)
      this.CommandForm.sort = this.selected[0].sort || 1
    },
    submitCommandForm(CommandFormName) {
      this.$refs[CommandFormName].validate((valid) => {
        if (valid) {
          let param = {
            typeId: this.typeId,
            name: this.CommandForm.name,
            aliKey: this.CommandForm.aliKey,
            keyType: this.CommandForm.keyType,
            explain: this.CommandForm.explain,
            unit: this.CommandForm.unit,
            isShow: this.CommandForm.isShow,
            operationType: 1,
            sort: this.CommandForm.sort,
          }
          if (this.btnCommand == 'add') {
            this.$store
              .dispatch('TerminalCommand/GET_INSERTALIKEY', param)
              .then((res) => {
                if (res.data.code == 200) {
                  this.$message.success(this.$t('common.btn.addSuccess'))
                  this.dialogCommandFormVisible = false
                  this.getInstructionType()
                  this.closeCommandDia()
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch((err) => { })
          } else {
            param.id = this.selected[0].id
            param.operationType = 2
            this.$store
              .dispatch('TerminalCommand/GET_INSERTALIKEY', param)
              .then((res) => {
                if (res.data.code == 200) {
                  this.$message.success(this.$t('common.btn.editSuccess'))
                  this.dialogCommandFormVisible = false
                  this.getInstructionType()
                  this.closeCommandDia()
                } else {
                  this.$message.error(res.data.msg)
                }
              })
              .catch((err) => { })
          }
        } else {
          return false
        }
      })
    },
    cancleCommand(CommandFormName) {
      this.dialogCommandFormVisible = false
      this.clear()
    },
    closeCommandDia() {
      this.clear()
      this.dialogCommandFormVisible = false
    },
    deleteCommand() {
      this.$confirm(this.$t('common.btn.confirmDelete'), this.$t('common.btn.hint'), {
        cancelButtonText: this.$t('common.btn.cancel'),
        confirmButtonText: this.$t('common.btn.confirm'),
        type: 'warning',
      })
        .then((res) => {
          let param = { id: this.selected[0].id }
          this.$store
            .dispatch('TerminalCommand/GET_DELETEALIKEY', param)
            .then((response) => {
              if (response.data.code == 200) {
                this.getTerminalType()
                this.$message.success(this.$t('common.btn.deleteSuccess'))
              } else {
                this.$message.error(response.data.msg)
              }
            })
            .catch((error) => { })
        })
        .catch((err) => { })
    },
    handleSelectionChange(val) {
      this.selected = val
    },
    changeSize(item) {
      this.pageSize = item.pageSize
      this.currentPage = item.pageNum
      this.getInstructionType()
    },
    onResize: function (x, y, width, height) {
      let box = document.getElementById('leftBox')
      box.style.width = width + 'px'
    },

    // 清除form表单数据
    clear() {
      this.CommandForm = {
        name: '',
        aliKey: '',
        keyType: '',
        sort: 1,
        explain: '',
        unit: '',
        isShow: '',
      }
    },
  },
}
